import React from 'react';
import { Instagram, Facebook, MapPin, Phone } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { trackButtonClick } from '../../utils/analytics';
import useHomePageContent from '../../hooks/useHomePageContent';

const Footer = () => {
  const { content } = useHomePageContent();
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  const handleWhatsAppClick = () => {
    trackButtonClick('WhatsApp Contact');
    window.open('https://wa.me/972545431009', '_blank');
  };

  const menuItems = [
    { id: 'about', label: 'О нас' },
    { id: 'programs', label: 'Программы' },
    { id: 'events', label: 'События' },
    { id: 'articles', label: 'Статьи' },
  ];

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">{content.footer_team_name}</h3>
            <p className="text-gray-400">{content.footer_team_description}</p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Ссылки</h4>
            <ul className="space-y-2">
              {menuItems.map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">
                  Политика конфиденциальности
                </Link>
              </li>
              <li>
                <Link to="/support" className="text-gray-400 hover:text-white transition-colors">
                  Поддержка приложения
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Контакты</h3>
            <div className="space-y-4">
              <div className="flex items-center">
                <MapPin className="w-5 h-5 mr-2" />
                <span>Израиль, Тель-Авив</span>
              </div>
              <div
                className="flex items-center cursor-pointer hover:text-blue-400 transition-colors"
                onClick={handleWhatsAppClick}
              >
                <Phone className="w-5 h-5 mr-2" />
                <span>+972 54 543-10-09</span>
              </div>
              <a href="mailto:info@leikinteam.co" className="block text-gray-400 hover:text-white transition-colors">
                info@leikinteam.co
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Соц. сети</h4>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/leikin_team/" className="p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="/" className="p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Leikin Team. Все права защищены.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
